import { render, staticRenderFns } from "./SkeletonBox.vue?vue&type=template&id=680c8bba&scoped=true&"
import script from "./SkeletonBox.vue?vue&type=script&lang=js&"
export * from "./SkeletonBox.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonBox.vue?vue&type=style&index=0&id=680c8bba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c8bba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oh/Projects/php_was2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('680c8bba')) {
      api.createRecord('680c8bba', component.options)
    } else {
      api.reload('680c8bba', component.options)
    }
    module.hot.accept("./SkeletonBox.vue?vue&type=template&id=680c8bba&scoped=true&", function () {
      api.rerender('680c8bba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/SkeletonBox.vue"
export default component.exports